<script>
    /* eslint-disable */
    import DiagnosticoOptions from './DiagnosticoOptions.vue';
    import ImageInput from './ImageInput.vue';
    import ModalArchivosConTipo from './ModalArchivosConTipo.vue';
    import { obligatorioAlfanumerico, obligatorioAlfanumericoSinCero, obligatorioNumerico, opcionalNumerico } from '@/_helpers/rules';

    export default {
        name: 'ItemPrestacion',
        components: {
            DiagnosticoOptions,
            ImageInput,
            ModalArchivosConTipo
        },
        props: {
            listadoPrestaciones: [],
            diagnosticos: [],
            obligatorio: [],
            mostrarDiagnostico: false,
            tiposDocumentacion: {
                type: Array,
                default: () => [],
            },
            nroAutorizacionPorPrestacion: false,
            aceptaNroAutorizacionCero: false,
            copagoObligatorio: false,
            mostrarCargaArchivos: {
                type: Boolean,
                default: true
            }
        },
        data : () => ({
            search: '',
            headers: [],
            obligatorioAlfanumerico: obligatorioAlfanumerico,
            obligatorioAlfanumericoSinCero: obligatorioAlfanumericoSinCero,
            obligatorioNumerico: obligatorioNumerico,
            opcionalNumerico: opcionalNumerico
        }),
        mounted(){
            this.headers = [
                { title: 'Código', key: 'Codigo' },
                { title: 'Descripción', key: 'Descripcion' },
                { title: 'Cantidad', key: 'Cantidad' },
                { title: 'Diagnóstico', key: 'IdDiagnostico' },
                { title: 'Número autorización', key: 'NroAutorizacion' },
                { title: 'Copago', key: 'Copago' },
                { title: 'Archivos', key: 'Imagenes' },
                { title: '', key: 'Operacion' }
            ]
            if(!this.mostrarDiagnostico){
                this.headers = this.headers.filter(header => header.key !== 'IdDiagnostico');
            }
            if(!this.nroAutorizacionPorPrestacion){
                this.headers = this.headers.filter(header => header.key !== 'NroAutorizacion');
            }
            if(!this.mostrarCargaArchivos){
                this.headers = this.headers.filter(header => header.key !== 'Imagenes');
            }
        },
        computed: {
            imagenesPorPrestacion() {
                // Retorna un objeto donde la key es el código de la prestación
                return this.listadoPrestaciones.reduce((acc, prestacion) => {
                    acc[prestacion.Codigo] = prestacion.Imagenes || [];
                    return acc;
                }, {});
            }
        },
        methods: {
            quitarPrestacion(codigo){
                this.$emit("eliminar-prestacion", codigo);
            },
            agregarArchivos(archivos, prestacion){
                prestacion.Imagenes = archivos;
            },
            tipoDocumentacion(valor){
                const tipo = this.tiposDocumentacion.find(tipo => tipo.valor === valor);
                return tipo ? `${tipo.nombre}-` : "";
            },
            actualizarCopagoSolicitud(){
                this.$emit("actualizar-copago-solicitud");
            },
            sobreescribeCopago() {
                return this.$store.getters.getObraSocial.configuracionOS.puedeSobreescribirCopago;
            }
        }
    }
</script>

<style src="../assets/general.css"></style>

<template>
    <v-card flat>
    <v-card-title class="d-flex align-center pe-2">
        <v-icon icon="mdi mdi-stethoscope"></v-icon>
        Prestaciones a solicitar

        <v-spacer></v-spacer>

        <v-text-field
        v-model="search"
        density="compact"
        label="Buscar"
        prepend-inner-icon="mdi-magnify"
        variant="solo-filled"
        flat
        hide-details
        single-line
        ></v-text-field>
        </v-card-title>
    
        <v-divider></v-divider>
        <v-data-table 
        v-model:search="search" 
        :items="listadoPrestaciones"
        :items-per-page="4"
        :items-per-page-options="[1, 2, 3, 4]"
        :items-per-page-text="'Elementos por pagina:'"
        :no-data-text="'No hay datos disponibles'"
        :loading-text="'Cargando...'"
        :search-text="'Buscar'"
        :headers="headers"
        >
            <template v-slot:item.Copago="{ item }">
                <v-row class="align-center justify-start" dense>
                    <v-col cols="auto" class="mt-4">
                        <v-text-field
                            style="min-width: 150px;"
                            v-model="item.Copago"
                            label="Copago"
                            justify-end
                            outlined
                            variant="solo"
                            density="compact"
                            :required="sobreescribeCopago() && copagoObligatorio"
                            
                            :class="(sobreescribeCopago() && copagoObligatorio) ? 'asterisco' : ''"
                            :readonly="!sobreescribeCopago()"
                            prepend-inner-icon="mdi mdi-currency-usd"
                            @update:model-value="actualizarCopagoSolicitud"
                        ></v-text-field>
                    </v-col>    
                </v-row>
            </template>
            <template v-slot:item.Imagenes="{ item }">
                <v-row class="align-center justify-start" dense>
                    <v-col cols="auto" class="mt-4" >
                        <ModalArchivosConTipo
                            @agregarArchivos="(archivos) => agregarArchivos(archivos, item)"
                            :tiposDocumentacion="tiposDocumentacion"
                        ></ModalArchivosConTipo>
                    </v-col>
                </v-row>
                <v-row class="align-center justify-start" dense>
                    <v-col cols="auto">
                        <v-chip-group color="#254126" direction="vertical">
                            <v-chip v-for="file in item.Imagenes" :key="file.nombre">{{this.tipoDocumentacion(file.tipoDocumentacion) +''+ file.nombre }}</v-chip>
                        </v-chip-group>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:item.IdDiagnostico="{ item }" v-if="mostrarDiagnostico">
                <DiagnosticoOptions
                    :obligatorio="obligatorio"
                    :diagnosticos="diagnosticos"
                    :diagnostico="diagnosticos.find(diagnostico => diagnostico.id === item.IdDiagnostico)"
                    v-model="item.IdDiagnostico"
                    style="margin-top: 10px; max-width: 300px;"
                ></DiagnosticoOptions>
            </template>

            <template v-slot:item.NroAutorizacion="{ item }">
                <v-text-field
                    v-model="item.NroAutorizacion"
                    label="Número de autorización"
                    justify-end
                    outlined
                    variant="solo"
                    density="compact"
                    clearable
                    required
                    :rules="aceptaNroAutorizacionCero ? obligatorioAlfanumerico : obligatorioAlfanumericoSinCero"
                    class="mt-10 asterisco"
                ></v-text-field>
            </template>

            <template v-slot:item.Operacion="{ item }">
                <v-btn
                    v-model="item.Operacion"
                    id="boton-rojo"
                    @click="quitarPrestacion(item.Codigo)"     
                >
                Quitar <v-icon icon="mdi mdi-close"></v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>